import React from 'react';
import { articlePropTypes } from './ArticlePropTypes';
import useArticleNewsletterForms from '@App/common/hooks/useArticleNewsletterForms';
import './components/Quote/Quote.scss';
import './components/Sources/Sources.scss';
import './components/Do/Do.scss';
import './components/Dont/Dont.scss';
import './components/Faq/Faq.scss';
import './components/KeyTakeaways/KeyTakeaways.scss';
import './components/Newsletter/Newsletter.scss';
import './components/OurTopPicks/OurTopPicks.scss';
import './components/Product/Product.scss';
import './components/ProductHorizontal/ProductHorizontal.scss';
import './components/ProductVertical/ProductVertical.scss';
import './components/ProsAndCons/ProsAndCons.scss';
import './components/Pros/Pros.scss';
import './components/Cons/Cons.scss';
import './components/Summary/Summary.scss';
import './components/ImportantInfo/ImportantInfo.scss';
import './components/CtaJutroMedical/CtaJutroMedical.scss';
import './components/Footnote/Footnote.scss';
import './components/HorizontalProduct/HorizontalProduct.scss';
import './components/VerticalProduct/VerticalProduct.scss';
import * as styles from './Article.module.scss';

/**
 * Article module
 */
const Article = ({
  children,
  onSubscribe,
  html
}) => {
  useArticleNewsletterForms(onSubscribe);
  return /*#__PURE__*/React.createElement(React.Fragment, null, html && /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }), children && /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, children));
};
export default Article;